const TONE_BY_GO_NOGO_VOTE = Object.freeze({
  go: 'success',
  nogo: 'destructive',
});

export function getGoNoGoVoteTone(vote) {
  if (typeof vote !== 'string') return 'neutral';
  return TONE_BY_GO_NOGO_VOTE[vote.toLowerCase()] || 'neutral';
}
